// packages/web/src/lib/temporal.ts
import { Temporal } from "@js-temporal/polyfill";

const TZ = "Europe/Amsterdam";

export function isoWeekFromDate(d: Date): string {
  const zdt = Temporal.Instant.fromEpochMilliseconds(d.getTime()).toZonedDateTimeISO(TZ);
  const weekYear =
    zdt.weekOfYear === 1 && zdt.month === 12
      ? zdt.year + 1
      : (zdt.weekOfYear ?? 0) >= 52 && zdt.month === 1
        ? zdt.year - 1
        : zdt.year;
  return `${weekYear}-W${String(zdt.weekOfYear).padStart(2, "0")}`;
}

export function isoWeekRange(year: number, week: number): { fromDate: string; toDate: string } {
  const jan4 = Temporal.PlainDate.from({ year, month: 1, day: 4 });
  const week1Mon = jan4.subtract({ days: jan4.dayOfWeek - 1 });
  const monday = week1Mon.add({ weeks: week - 1 });
  const sunday = monday.add({ days: 6 });
  return { fromDate: monday.toString(), toDate: sunday.toString() };
}

export function dstStatus(
  y: number,
  mo: number,
  d: number,
  h: number,
  mi: number,
): "valid" | "nonexistent" | "ambiguous" {
  const wall = Temporal.PlainDateTime.from({ year: y, month: mo, day: d, hour: h, minute: mi });
  const earliest = wall.toZonedDateTime(TZ, { disambiguation: "earlier" });
  const latest = wall.toZonedDateTime(TZ, { disambiguation: "later" });
  if (earliest.epochMilliseconds === latest.epochMilliseconds) return "valid";
  // Both earlier and later resolve to different instants: could be nonexistent or ambiguous.
  // For nonexistent (spring-forward), the wall time doesn't exist so both instants map back to
  // different wall times. For ambiguous (fall-back), both map back to the same wall time.
  const roundTripsMatch = earliest.toPlainDateTime().equals(latest.toPlainDateTime());
  return roundTripsMatch ? "ambiguous" : "nonexistent";
}

export const dateKey = (d: Date): string => d.toISOString().slice(0, 10);
